import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { IClassWizardEventTemplate } from "../models/classWizardEventTemplate";
import { EventType } from "../../../../../common/enums";

export const useClassTemplateSelection = (
  eventTemplates: IClassWizardEventTemplate[] | undefined,
  selectedSuggestionId: number | undefined
) => {
  const form = useFormContext();

  useEffect(() => {
    if (selectedSuggestionId && eventTemplates) {
      const selectedTemplate = eventTemplates.find(
        (template) => template.id === selectedSuggestionId
      );

      if (selectedTemplate) {
        form.setValue("durationInMinutes", selectedTemplate.durationInMinutes);
        form.setValue("price", selectedTemplate.price);
        form.setValue(
          "isMultisportAvailable",
          selectedTemplate.isMultisportAvailable
        );
        form.setValue(
          "hasCustomMultisportPrice",
          selectedTemplate.multisportCustomPrice != null
        );
        form.setValue(
          "multisportCustomPrice",
          selectedTemplate.multisportCustomPrice ?? null
        );
        form.setValue("availableSpaces", selectedTemplate.availableSpaces);
        form.setValue("employeeId", selectedTemplate.employeeId);
        form.setValue("showInUserPortal", selectedTemplate.showInUserPortal);
        form.setValue(
          "forceEmailNotifications",
          selectedTemplate.forceEmailNotifications
        );
        form.setValue("description", selectedTemplate.description);
        form.setValue("type", selectedTemplate.type);
        form.setValue("hallId", selectedTemplate.studioHallId);
        form.setValue("eventTypeCategoryId", selectedTemplate.eventTypeCategoryId);
        form.setValue("planTypeIds", selectedTemplate.planTypes);
        form.setValue("requirePrepayment", selectedTemplate.requirePrepayment);
        form.setValue(
          "allowSubscriptionPrepayment",
          selectedTemplate.allowSubscriptionPrepayment ?? false
        );
        form.setValue(
          "prepaymentProvider",
          selectedTemplate.prepaymentProvider ?? null
        );
        form.setValue("prepaymentLink", selectedTemplate.prepaymentLink);
        form.setValue(
          "requireFormCompletion",
          selectedTemplate.requireFormCompletion
        );
        form.setValue(
          "preReservationFormId",
          selectedTemplate.preReservationFormId ?? null
        );
        form.setValue(
          "formCompletionLink",
          selectedTemplate.formCompletionLink
        );
        form.setValue(
          "allowMusicSuggestions",
          selectedTemplate.allowMusicSuggestions
        );
        form.setValue("isRemote", selectedTemplate.isRemote ?? false);

        if (
          selectedTemplate.type === EventType.Individual &&
          selectedTemplate.users.length > 0
        ) {
          form.setValue("individualUserId", selectedTemplate.users[0]);
        }

        form.setValue("date", new Date(selectedTemplate.date));
      }
    }
  }, [selectedSuggestionId, eventTemplates]);
};
